(function () {
  function loadVimeo(el) {
    var id = el.getAttribute('data-vimeo-id');
    if (!id || el.dataset.atfvLoaded) return;
    el.dataset.atfvLoaded = '1';
    el.innerHTML =
      '<iframe src="https://player.vimeo.com/video/' +
      id +
      '?autoplay=1&muted=1&title=0&byline=0&portrait=0" allow="autoplay; fullscreen; picture-in-picture" title="White Tiger Qigong video" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"></iframe>';
  }

  document.querySelectorAll('[data-atfv-video]').forEach(function (el) {
    el.addEventListener('click', function () {
      loadVimeo(el);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        loadVimeo(el);
      }
    });
  });
})();
